import { render, staticRenderFns } from "./UserSettingAvailableGame.vue?vue&type=template&id=95057c44&scoped=true&"
import script from "./UserSettingAvailableGame.vue?vue&type=script&lang=js&"
export * from "./UserSettingAvailableGame.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingAvailableGame.vue?vue&type=style&index=0&id=95057c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95057c44",
  null
  
)

export default component.exports